import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";
import { StorageBreakdownSortType } from "@/types/graphql/partner.generated";

// CRITICAL-RULES.md — i18n партнёр-кабинета: ключ i18n только статический
// литерал, подпись по значению enum — через явную мапу.
const SORT_OPTIONS: { value: StorageBreakdownSortType; labelKey: string }[] = [
  {
    value: StorageBreakdownSortType.StorageCostDescType,
    labelKey: "storage.filter.sort.storageCostDesc",
  },
  {
    value: StorageBreakdownSortType.CreatedAscType,
    labelKey: "storage.filter.sort.createdAsc",
  },
];

/**
 * Карточка фильтра «Хранилища» в общем стиле списков кабинета: сортировка и
 * отбор «только без просмотров» лежат внутри карточки, а не на фоне
 * страницы. Оба поля всегда видны, поэтому кнопка «раскрыть фильтр» не
 * рисуется.
 */
export const StorageFilter: FC = () => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("storage.pageTitle")}
      alwaysVisible={["sort", "onlyUnwatched"]}
      selects={[
        {
          name: "sort",
          label: t("storage.filter.sortLabel"),
          hideAnyOption: true,
          defaultValue: StorageBreakdownSortType.StorageCostDescType,
          options: SORT_OPTIONS.map(({ value, labelKey }) => ({
            value,
            label: t(labelKey),
          })),
        },
        {
          name: "onlyUnwatched",
          label: t("storage.filter.viewsLabel"),
          options: [
            { value: "true", label: t("storage.filter.onlyUnwatched") },
          ],
        },
      ]}
    />
  );
};
